import classes from "./media_manager_sidebar.module.scss";
import { BiEditAlt, BiRotateLeft } from "react-icons/bi";
import { useAppDispatch } from "@common-reducers/hooks/store.hook";
import { mediaManager } from "@common-reducers/MediaManagerReducer";
import { useAppSelector } from "@common-reducers/hooks/store.hook";

const MediaManagerSideBar = () => {
    const dispatch = useAppDispatch()
    const showVersions = useAppSelector((state) => state.MediaManagerReducer.showVersionTab);
    const showEdit = useAppSelector((state) => state.MediaManagerReducer.showEditTab);

    function toggleVersions() {
        dispatch(mediaManager.setVersionTab(!showVersions));
    }

    function toggleEdit() {
        dispatch(mediaManager.setEditTab(!showEdit));
    }

    return (
        <div className={classes.mediaSideBar}>
            <button
                type="button"
                className={`${classes.railBtn} ${showVersions ? classes.railBtnActive : ''}`}
                onClick={toggleVersions}
                aria-pressed={showVersions}
            >
                <BiRotateLeft className={classes.railIcon} />
                <span>Versions</span>
            </button>

            <button
                type="button"
                className={`${classes.railBtn} ${showEdit ? classes.railBtnActive : ''}`}
                onClick={toggleEdit}
                aria-pressed={showEdit}
            >
                <BiEditAlt className={classes.railIcon} />
                <span>Edit</span>
            </button>
        </div>
    )
}

export default MediaManagerSideBar
